import { connect } from 'react-redux';

import RemoteDoormanPopUpComponent from './RemoteDoormanPopUpComponent';

import { uploadImage } from '../Visitor/actionCreators';
import {
  createPopUp,
  deletePopUp,
  deletePopUpPhoto,
  updatePopUp,
} from './actions';

const form = 'RemoteDoormanPopUp';

const mapStateToProps = (state, ownProps) => {
  const { remoteDoormanPopup } = ownProps;
  const isUpdate = Boolean(remoteDoormanPopup?.id);
  let initialValues = {
    headline: '',
    body: '',
    image: null,
    isDeleteImage: false,
  };
  if (isUpdate) {
    initialValues = { ...initialValues, ...remoteDoormanPopup };
  }
  return {
    form,
    initialValues,
    isUpdate,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { onModalClose, buildingId, remoteDoormanPopup, onCloseCallback } =
    ownProps;
  return {
    onSubmit: async (formValues) => {
      const { image, isDeleteImage, ...rest } = formValues;
      const data = { ...rest, building: buildingId };

      let res = null;
      if (isDeleteImage)
        deletePopUpPhoto(dispatch, data?.id, remoteDoormanPopup?.photo?.id);
      if (data?.id) {
        res = await updatePopUp(dispatch, data);
      } else {
        res = await createPopUp(dispatch, data);
      }

      const { id: popUpId, photoUploadUrl } = res?.data || {};
      if (!popUpId) return;
      if (image) await uploadImage(dispatch, image, photoUploadUrl);
      onCloseCallback();
      onModalClose();
    },
    onDeletePopUp: async () => {
      await deletePopUp(dispatch, remoteDoormanPopup?.id);
      onCloseCallback();
      onModalClose();
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoteDoormanPopUpComponent);
